import { Moment } from "moment";

import { ValuesForHourPicker } from "models/Date";

export function generateHoursForPicker(start: Moment, amount = 48): ValuesForHourPicker {
    const startOfDay = start.clone().startOf("day");
    return Array(amount).fill(null).map((_, i) => {
        const date = startOfDay.clone().add(i * 30, "minutes");
        return {
            date,
            disabled: false,
            formatted: date.format("HH:mm"),
        };
    }).filter(({ date }) => date.isAfter(startOfDay.clone().set({ hour: 8, minute: 59 })));
}
